module.exports = __webpack_public_path__ + "img/26.d90d2d25.png";